import { cn, Modal, ModalBody, useOpenable } from '@execonline-inc/execonline-ui';
import { AlreadyTranslatedText } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import { VideoSourceFile } from '../../../../components/JWPlayer/Types';
import { dataLayerUpdate } from '../../../../components/Tooling/GoogleTagManagerTooling/Loader';
import { OverviewVideoResource } from '../../../../components/ReqHlsVideo/Types';
import ExperienceVideoDetailsModalBody from './ExperienceVideoDetailsModalBody';
import ExperienceVideoPreviewModalBody from './ExperienceVideoPreviewModalBody';
import ExperienceVideoThumbnail from './ExperienceVideoThumbnail';
import ExperiencesStore from '../../DiscoveryPortal/ExperienceSelection/Experiences/ExperiencesStore';

interface Props {
  className?: string;
  title: AlreadyTranslatedText;
  video: OverviewVideoResource;
  thumbnail: string;
  sources: VideoSourceFile[];
  experiencesStore: ExperiencesStore;
}

function ExperienceVideoDetails({
  className,
  title,
  thumbnail,
  sources,
  video,
  experiencesStore,
}: Props) {
  const { isOpen, onOpen, onClose } = useOpenable();

  const openVideo = () => {
    dataLayerUpdate({ event: 'discovery-portal-video-open', videoTitle: title.text });
    onOpen();
  };

  return (
    <>
      <ExperienceVideoThumbnail
        className={className}
        alt={title.text}
        src={thumbnail}
        onClick={openVideo}
      />
      <Modal
        className="h-full rounded-none sm:h-150 sm:rounded"
        classNames={{
          closeButton: 'z-1 text-white left-5 right-auto sm:left-auto sm:right-5 sm:text-gray-600',
        }}
        open={isOpen}
        size="5xl"
        onClose={onClose}
      >
        <ModalBody
          className={cn(
            'w-full px-0 pb-0 pt-14 sm:px-0 sm:pb-0 sm:pt-14',
            'grid grid-rows-[1fr_2fr] sm:grid-cols-[auto_19.875rem] sm:grid-rows-none',
          )}
        >
          <div className="-mt-14 flex-grow">
            <ExperienceVideoPreviewModalBody sources={sources} video={video} />
          </div>
          <div className="relative sm:w-[19.875rem]">
            <ExperienceVideoDetailsModalBody
              onClose={onClose}
              experiencesStore={experiencesStore}
            />
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default observer(ExperienceVideoDetails);
